import {useMutation, useQuery} from 'react-query';
import {ApiError, Body_send_support, FaqCategory, SupportCategory} from '../types';
import {HelpService} from '../types/services/HelpService';
import {FAQ_GET, FAQ_GET_CAMPAIGN, SUPPORT_GET, SUPPORT_GET_CAMPAIGN} from './keys';

export function useGetFaq(initialData: FaqCategory[] | null | undefined) {
    let options = {};
    if (initialData) {
        options = {
            initialData: initialData,
        };
    } else {
        options = {};
    }

    return useQuery(FAQ_GET, HelpService.getFaq, options);
}

export function useGetSupport(initialData: SupportCategory[] | null | undefined) {
    let options = {};
    if (initialData) {
        options = {
            initialData: initialData,
        };
    } else {
        options = {};
    }
    return useQuery(SUPPORT_GET, HelpService.getSupport);
}

export function useSendSupport() {
    return useMutation<boolean, ApiError, Body_send_support>((body: Body_send_support) =>
        HelpService.sendSupport(body)
    );
}

export function useGetCampaignFaq(campaignId: string) {
    return useQuery(FAQ_GET_CAMPAIGN + ':' + campaignId, () =>
        HelpService.getFaqByCampaign(campaignId)
    );
}

export function useGetCampaignSupport(campaignId: string) {
    return useQuery(SUPPORT_GET_CAMPAIGN + ':' + campaignId, () =>
        HelpService.getSupportByCampaign(campaignId)
    );
}
